"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmBuyCardNormal
 * @author xlongjiang
 * @created 2025-11-10 08:34:19
 */

const TabPanel = _tpmProductIntl.Tab.TabPanel;
const Row = _tpmProductIntl.Grid.Row,
  Col = _tpmProductIntl.Grid.Col;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmBuyCardNormalData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$tabList = _ref.tabList,
    tabList = _ref$tabList === void 0 ? [] : _ref$tabList;
  const handleTabList = tabList.map((tab, index) => {
    const _tab$text = tab.text,
      text = _tab$text === void 0 ? '' : _tab$text,
      columns = tab.columns,
      _tab$itemList = tab.itemList,
      itemList = _tab$itemList === void 0 ? [] : _tab$itemList;
    const handleItemList = itemList.map((item, key) => {
      const _item$titleText = item.titleText,
        titleText = _item$titleText === void 0 ? '' : _item$titleText,
        _item$titleHref = item.titleHref,
        titleHref = _item$titleHref === void 0 ? '' : _item$titleHref,
        _item$configList = item.configList,
        configList = _item$configList === void 0 ? [] : _item$configList,
        _item$tagList = item.tagList,
        tagList = _item$tagList === void 0 ? [] : _item$tagList,
        _item$integerCost = item.integerCost,
        integerCost = _item$integerCost === void 0 ? '' : _item$integerCost,
        _item$decimalCost = item.decimalCost,
        decimalCost = _item$decimalCost === void 0 ? '' : _item$decimalCost,
        _item$priceUnit = item.priceUnit,
        priceUnit = _item$priceUnit === void 0 ? '' : _item$priceUnit,
        _item$originalCost = item.originalCost,
        originalCost = _item$originalCost === void 0 ? '' : _item$originalCost,
        _item$freeText = item.freeText,
        freeText = _item$freeText === void 0 ? '' : _item$freeText,
        _item$btnList = item.btnList,
        btnList = _item$btnList === void 0 ? [] : _item$btnList;
      const handleBtnList = btnList.map((btn, btnIndex) => {
        const _btn$type = btn.type,
          type = _btn$type === void 0 ? 'primary' : _btn$type,
          _btn$text = btn.text,
          text = _btn$text === void 0 ? '' : _btn$text,
          _btn$href = btn.href,
          href = _btn$href === void 0 ? '' : _btn$href;
        const btnExtendProps = {
          'report-event': 'click_BuyCard_Normal_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnIndex,
          target: '_blank'
        };
        if (type === 'weak') {
          return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            type: "weak",
            href: href
          }, btnExtendProps), text);
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: href
        }, btnExtendProps), text);
      });
      return {
        title: titleText ? {
          text: titleText !== null && titleText !== void 0 ? titleText : '',
          href: titleHref !== null && titleHref !== void 0 ? titleHref : null,
          target: '_blank'
        } : null,
        configList,
        tagList,
        integerCost,
        decimalCost,
        priceUnit,
        originalCost,
        freeText,
        btn: !!btnList.length ? handleBtnList : null
      };
    });
    return {
      text,
      columns,
      itemList: handleItemList
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    tabList: handleTabList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmBuyCardNorm = formatTpmBuyCardNormalData(data, {
        domains
      }),
      porintId = _formatTpmBuyCardNorm.porintId,
      tag = _formatTpmBuyCardNorm.tag,
      title = _formatTpmBuyCardNorm.title,
      desc = _formatTpmBuyCardNorm.desc,
      bg = _formatTpmBuyCardNorm.bg,
      bgColor = _formatTpmBuyCardNorm.bgColor,
      bgImg = _formatTpmBuyCardNorm.bgImg,
      tabList = _formatTpmBuyCardNorm.tabList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmBuyCardNormal`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmBuyCardNormal', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, tabList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: tabList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, tabList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`
    }, /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: {
        whole: 4,
        pad: 4,
        phone: 4
      }
    }, item.itemList.map((card, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / item.columns,
      pad: 24,
      phone: 24
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.BuyCard, Object.assign({}, card, {
      key: key
    })))))))) : tabList.map((item, index) => /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: {
        whole: 4,
        pad: 4,
        phone: 4
      }
    }, item.itemList.map((card, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / item.columns,
      pad: 24,
      phone: 24
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.BuyCard, Object.assign({}, card, {
      key: key
    }))))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}